import { RUNTIME_ENVIRONMENT } from 'src/dataLayer/env';
import { getTrackingUUID } from 'src/dataLayer/localData/cookies.ts';

export default () => {
  if (RUNTIME_ENVIRONMENT === 'development') return true;
  return Boolean(getTrackingUUID());
};
